import { Fragment, type ReactNode } from 'react';
import { Link } from 'react-router';

export interface Crumb {
  label: ReactNode;
  /** Absent on the last crumb: the page the person is on. */
  to?: string;
}

/** Where the page sits: the levels above as links, the current one as plain text. */
export function Breadcrumb({ items, className }: { items: Crumb[]; className?: string }) {
  return (
    <nav
      aria-label="Breadcrumb"
      className={['flex flex-wrap items-center gap-1.5 text-body text-ink-3', className]
        .filter(Boolean)
        .join(' ')}
    >
      {items.map((item, index) => (
        <Fragment key={index}>
          {index > 0 ? <span aria-hidden="true">/</span> : null}
          {item.to ? (
            <Link to={item.to}>{item.label}</Link>
          ) : (
            <span aria-current="page" className="text-ink-2">
              {item.label}
            </span>
          )}
        </Fragment>
      ))}
    </nav>
  );
}
